import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from "./components/confirmation-dialog/confirmation-dialog.component";
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import {TranslationModule} from "src/app/kernel/translations/modules/translation.module";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { PopupService } from "./services/confirmation-popup/popup.service";

@NgModule({
  declarations: [ConfirmationDialogComponent, AlertDialogComponent],
  imports: [
    CommonModule,
    TranslationModule,
    DynamicDialogModule
  ],
  providers: [PopupService, DialogService],
  exports: [ConfirmationDialogComponent]
})
export class ConfirmationPopupModule { }
